import { render, staticRenderFns } from "./fghotj.vue?vue&type=template&id=20637c8e&scoped=true&"
import script from "./fghotj.vue?vue&type=script&lang=js&"
export * from "./fghotj.vue?vue&type=script&lang=js&"
import style0 from "./fghotj.vue?vue&type=style&index=0&id=20637c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20637c8e",
  null
  
)

export default component.exports